import styled from 'styled-components';
import { color } from 'styles/settings';
import { withModifiers } from 'utils/styles';

export const ActionsContainer = styled.div`
  position: absolute;
  z-index: ${({ menuVisible }) => (menuVisible ? '1' : '0')};
`;

export const ActionsMenu = styled.div`
  border: 1px solid #4a4a4a;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 5px 15px;
  min-width: 150px;
  top: ${({ top }) => top};
  right: 20px;
  position: absolute;
  visibility: hidden;
  width: max-content;
  ${withModifiers('visible')`
    visibility: visible;
  `};
`;

export const MenuItem = styled.div`
  align-items: center;
  background-color: ${color.neutral.grayLight};
  flex-direction: row;
  justify-content: center;
  margin: 5px 0;
  padding: 0 5px;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 10px 5px;
  width: 100%;
`;
